import React from 'react';
import { FaTrash, FaExclamationTriangle, FaTimes, FaUndo, FaQuestionCircle, FaCheckCircle } from 'react-icons/fa';
import './ConfirmModal.css';

const ConfirmModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Are you sure?", 
    message = "This action cannot be undone.", 
    confirmText = "Confirm", 
    cancelText = "Cancel",
    type = "danger", // danger, warning, primary, success
    singleButton = false
}) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'danger': return <FaTrash size={32} />;
            case 'warning': return <FaExclamationTriangle size={32} />;
            case 'primary': return <FaQuestionCircle size={32} />;
            case 'success': return <FaCheckCircle size={32} />;
            default: return <FaExclamationTriangle size={32} />;
        }
    };

    return (
        <div className="confirm-modal-overlay fade-in">
            <div className={`confirm-modal-card slide-up type-${type}`}>
                <div className="confirm-modal-close" onClick={onClose}>
                    <FaTimes />
                </div>
                
                <div className="confirm-modal-icon-container">
                    <div className="confirm-icon-bg">
                        {getIcon()}
                    </div>
                </div>

                <div className="confirm-modal-content">
                    <h3>{title}</h3>
                    <div className="confirm-message-wrapper">
                        {message.split('\n').map((line, i) => (
                            <p key={i}>{line}</p>
                        ))}
                    </div>
                </div>

                <div className="confirm-modal-actions">
                    {!singleButton && (
                        <button 
                            className="confirm-btn-cancel" 
                            onClick={onClose}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className={`confirm-btn-confirm btn-${type}`} 
                        style={{ width: singleButton ? '100%' : 'auto' }}
                        onClick={() => {
                            if (onConfirm) onConfirm();
                            onClose();
                        }}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
